import script from "./ArticleList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ArticleList.vue?vue&type=script&lang=ts&setup=true"

import "./ArticleList.vue?vue&type=style&index=0&id=6bca964b&lang=scss"

const __exports__ = script;

export default __exports__